const f = {
  color: {
    light: {
      text: "#405261ff",
      bg: "#dfe6ebff"
    },
    dark: {
      text: "#fff",
      bg: "#556575ff"
    }
  }
};
export {
  f as badgeKeyboard
};
